import React from 'react';
import { useStyles } from './HomePage.styles';
import TimezoneDateTime from './TimezoneDateTime';

function DeploymentFooter({ deploymentInfo }) {
  const classes = useStyles();

  if (!deploymentInfo) {
    return null;
  }

  const currentYear = new Date().getFullYear();

  return (
    <footer className={classes.footer}>
      <div className={classes.footerContent}>
        <div className={classes.footerSection}>
          <span className={classes.footerLabel}>Environment:</span>
          <span className={classes.footerValue}>{deploymentInfo.environment}</span>
        </div>
        <span className={classes.footerSeparator}>|</span>
        <div className={classes.footerSection}>
          <span className={classes.footerLabel}>Started At:</span>
          <span className={classes.footerValue}>
            {deploymentInfo.startedAt ? <TimezoneDateTime value={deploymentInfo.startedAt} /> : 'N/A'}
          </span>
        </div>
        <span className={classes.footerSeparator}>|</span>
        <div className={classes.footerSection}>
          <span className={classes.footerLabel}>Host:</span>
          <span className={classes.footerValue}>{deploymentInfo.hostname}</span>
        </div>
        <span className={classes.footerSeparator}>|</span>
        <div className={classes.footerSection}>
          <span className={classes.footerLabel}>Region:</span>
          <span className={classes.footerValue}>{deploymentInfo.region || 'N/A'}</span>
        </div>
        <span className={classes.footerSeparator}>|</span>
        <span className={classes.footerCopyright}>© {currentYear} Lego</span>
      </div>
    </footer>
  );
}

export default DeploymentFooter;